export default "__VITE_ASSET__DUU1mhjo__"